import makeQueryKey from "../../../../utils/make-query-key";
export var PARTNER_CART_PREORDER_QUERY_KEY = 'buy/partner_cart_preorder/v2';
var getPartnerCartPreorderQueryKey = function getPartnerCartPreorderQueryKey(_ref) {
  var paypalClicked = _ref.paypalClicked,
    id = _ref.id;
  return makeQueryKey([PARTNER_CART_PREORDER_QUERY_KEY, {
    paypalClicked: paypalClicked,
    id: id
  }]);
};
export default getPartnerCartPreorderQueryKey;